// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Eej4wNCXU48QkgvVOieK{flex-direction:column;gap:24px;display:flex}.Nylf9xQIgo9IK_Z7QH1V{padding-left:12px}.meDscfyXjt0p126eJp42{display:flex}.meDscfyXjt0p126eJp42 .AfSTkIzy0gZIx53j5Bl2{flex-direction:column;flex-grow:1;gap:4px;display:flex}.meDscfyXjt0p126eJp42 .tvbIwgSS0q0erdKcnX_e{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Eej4wNCXU48QkgvVOieK`,
	"textField": `Nylf9xQIgo9IK_Z7QH1V`,
	"switchField": `meDscfyXjt0p126eJp42`,
	"left": `AfSTkIzy0gZIx53j5Bl2`,
	"switch": `tvbIwgSS0q0erdKcnX_e`
};
export default ___CSS_LOADER_EXPORT___;
